<template>
  <div style="background-color: black; height: 100%;">
    <!-- Back Button -->
    <v-btn
      icon
      style="z-index: 99; position: absolute; top: 16px; left: 16px;"
      class="mb-12 white--text"
      @click="$router.go(-1)"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <!-- Title -->
    <v-row justify="center">
      <v-col cols="12" md="8">
        <h2 class="job-title my-4 text-center">Edit Delivery</h2>
      </v-col>
    </v-row>

    <div class="pa-6" style="background-color:white;border-radius:20px 20px 0px 0px;height:90vh">
      <!-- Overlay Loader -->
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-form ref="form" v-model="valid">
        <!-- Form Fields (4 columns per row) -->
        <v-row dense>
          <!-- Delivery Number (Always Readonly) -->
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="delivery.deliveryNumber"
              label="Delivery Number"
              dense
              outlined
              rounded
              :rules="[rules.required]"
              readonly
            ></v-text-field>
          </v-col>

          <!-- Delivery Method (Disabled when status is 'Booked') -->
          <v-col cols="12" sm="3">
            <v-select
              v-model="delivery.method"
              :items="methods"
              label="Delivery Method"
              dense
              outlined
              rounded
              :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
              :rules="[rules.required]"
              @change="handleMethodChange"
            ></v-select>
          </v-col>

          <!-- Type (Disabled when status is 'In Transit') -->
          <v-col cols="12" sm="3">
            <v-select
              v-model="delivery.type"
              :items="filteredTypes"
              label="Type"
              dense
              outlined
              rounded
              :disabled="delivery.status === 'In Transit'||delivery.status === 'Complete'|| delivery.status === 'Delayed'"
              :rules="[rules.required]"
            ></v-select>
          </v-col>

          <!-- Driver Name (Disabled when status is 'In Transit') -->
         <!-- Driver Name Field -->
<v-col cols="12" sm="3">
  <v-text-field
    v-model="delivery.driverName"
    label="Driver Name"
    dense
    outlined
    rounded
    :rules="driverNameRules"
    :disabled="delivery.status === 'Complete' || delivery.status === 'Delayed'"
  ></v-text-field>
</v-col>

        </v-row>

        <v-row dense>
          <!-- Invoice Number (Disabled when status is 'Booked') -->
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="delivery.invoice"
              label="Invoice Number (Optional)"
              dense
              outlined
              rounded
              :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
            ></v-text-field>
          </v-col>

          <!-- PO Number (Disabled when status is 'Booked') -->
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="delivery.poNumber"
              label="PO Number (Optional)"
              dense
              outlined
              rounded
              :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
            ></v-text-field>
          </v-col>

          <!-- Location (Disabled when status is 'Booked') -->
          <v-col cols="12" sm="3">
            <v-autocomplete
              v-model="delivery.location"
              :items="combinedLocations"
              label="Location (Suppliers & Customers)"
              dense
              outlined
              rounded
              :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
              :rules="[rules.required]"
              item-text="name"
              item-value="account"
              :loading="loadingLocations"
              prepend-inner-icon="mdi-map-marker"
            ></v-autocomplete>
          </v-col>

          <!-- Engineer (Disabled when status is 'Booked') -->
          <v-col cols="12" sm="3">
            <v-select
              v-model="delivery.engineer"
              :items="engineers"
              label="Engineer"
              dense
              outlined
              rounded
              :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
              :rules="[!isSalespersonSelected ? rules.required : []]"
            ></v-select>
          </v-col>
        </v-row>

        <v-row dense>
          <!-- Salesperson (Disabled when status is 'Booked') -->
          <v-col cols="12" sm="3">
            <v-select
              v-model="delivery.salesperson"
              :items="salespersons"
              label="Salesperson"
              dense
              outlined
              rounded
              :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
              :rules="[!isEngineerSelected ? rules.required : []]"
            ></v-select>
          </v-col>

          <!-- Urgency (Disabled when status is 'Booked') -->
          <v-col cols="12" sm="3">
            <v-select
              v-model="delivery.urgency"
              :items="urgencies"
              label="Urgency"
              dense
              outlined
              rounded
              :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
              :rules="[rules.required]"
            ></v-select>
          </v-col>

          <!-- Date Picker (Disabled when status is 'Booked') -->
          <v-col cols="12" sm="3">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedDate"
                  label="Date"
                  outlined
                  rounded
                  dense
                  prepend-inner-icon="mdi-calendar"
                  :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker 
                v-model="delivery.date" 
                @input="menu = false" 
                :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
                scrollable>
              </v-date-picker>
            </v-menu>
          </v-col>

          <!-- Time Picker (Disabled when status is 'Booked') -->
          <v-col cols="12" sm="3">
            <v-menu
              ref="timeMenu"
              v-model="timeMenu"
              :close-on-content-click="false"
              :return-value.sync="delivery.time"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="delivery.time"
                  label="Time"
                  dense
                  outlined
                  rounded
                  :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  prepend-inner-icon="mdi-clock"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="delivery.time"
                @input="timeMenu = false"
                :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
              ></v-time-picker>
            </v-menu>
          </v-col>

          <!-- Reference Number (Disabled when status is 'Booked') -->
          

          <!-- Status (Always Editable) -->
          <v-col cols="12" sm="3">
            <v-select
              v-model="delivery.status"
              :items="statuses"
              label="Status"
              dense
              outlined
              rounded
              :rules="[rules.required]"
            ></v-select>
          </v-col>
        </v-row>

        <!-- Dynamic Delivery Items -->
        <v-row>
          <h2 class="red--text mx-12" style="margin-bottom: 30px;">DELIVERY ITEMS</h2>
          <v-spacer></v-spacer>
        </v-row>
        <div v-for="(item, index) in deliveryItems" :key="index">
          <v-row dense>
            <!-- QTY (Disabled when status is 'Booked') -->
            <v-col cols="12" sm="2">
              <v-text-field
                v-model="item.qty"
                label="QTY"
                outlined
                rounded
                dense
                prepend-inner-icon="mdi-numeric"
                :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
              ></v-text-field>
            </v-col>

            <!-- Code (Disabled when status is 'Booked') -->
            <v-col cols="12" sm="2">
              <v-text-field
                v-model="item.code"
                label="Code"
                outlined
                rounded
                dense
                prepend-inner-icon="mdi-numeric"
                :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
              ></v-text-field>
            </v-col>

            <!-- Description (Disabled when status is 'Booked') -->
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="item.description"
                label="Description"
                outlined
                rounded
                dense
                prepend-inner-icon="mdi-numeric"
                :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
              ></v-text-field>
            </v-col>

            <!-- Reference Number (Disabled when status is 'Booked') -->
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="item.refnum"
                label="Reference Number"
                outlined
                rounded
                dense
                prepend-inner-icon="mdi-numeric"
                :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
              ></v-text-field>
            </v-col>

            <!-- For Field (Disabled when status is 'Booked') -->
            <v-col cols="12" sm="2" v-if="delivery.type === 'Both'">
              <v-select
                v-model="item.for"
                :items="['Delivery', 'Collection']"
                label="For"
                outlined
                rounded
                dense
                :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
              ></v-select>
            </v-col>

            <!-- Remove Button (Disabled when status is 'Booked') -->
            <v-col cols="12" sm="1">
              <v-btn icon @click="removeDeliveryItem(index)" color="red" :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <!-- Add More Delivery Items (Disabled when status is 'Booked') -->
        <v-row justify="left" class="mt-3">
          <v-btn
            color="black"
            outlined
            dark
            width="300px"
            rounded
            @click="addMoreDeliveryItems"
            :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
          >
            <v-icon left>mdi-plus-circle-outline</v-icon>Add More Delivery Items
          </v-btn>
        </v-row>

        <!-- Reason for Delivery/Collection (Disabled when status is 'Booked') -->
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="delivery.reason"
              label="Reason for Delivery/Collection"
              dense
              outlined
              rounded
              :disabled="delivery.status === 'Booked'||delivery.status === 'In Transit'|| delivery.status === 'Complete'|| delivery.status === 'Delayed'"
              :rules="[reasonRequired ? rules.required : []]"
            ></v-textarea>
          </v-col>
        </v-row>

        <!-- Display Uploaded Photos -->
        <v-row v-if="delivery.photos.length">
          <v-col cols="12" sm="2" v-for="(photo, index) in delivery.photos" :key="index">
            <v-img :src="photo" class="ma-2" height="100px" width="100px" contain></v-img>
          </v-col>
        </v-row>

        <!-- Save Button with Confirmation Dialog -->
        <v-row justify="center" dense>
          <v-btn rounded color="black" dense width="400px" dark @click="confirmSave">
            <v-icon left>mdi-content-save</v-icon>Save Changes
          </v-btn>
        </v-row>
      </v-form>

      <!-- Snackbar for Success Message -->
      <v-snackbar v-model="snackbar" :timeout="4000" top color="green" dark>
        Delivery updated successfully!
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>

      <!-- Confirmation Dialog -->
      <v-dialog v-model="confirmDialog" max-width="400">
        <v-card>
          <v-card-title class="headline">Confirm Changes</v-card-title>
          <v-card-text>Are you sure you want to save these changes?</v-card-text>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="submit">Yes</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="confirmDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import {
  getFirestore,
  doc,
  getDoc,
  updateDoc,
  collection,
  getDocs,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { firebaseApp } from "@/firebaseConfig";

const db = getFirestore(firebaseApp);

export default {
  data() {
    return {
      valid: false,
      delivery: {
        deliveryNumber: "",
        method: "",
        type: "",
        refNumber: "",
        invoice: "",
        poNumber: "",
        location: "",
        engineer: "",
        salesperson: "",
        reason: "",
        urgency: "",
        date: "",
        time: "",
        driverName: "", // Added driverName field
        status: "",
        photos: [],
      },
      deliveryItems: [
        {
          qty: "",
          code: "",
          description: "",
          refnum: "",
        },
      ],
      methods: ["Driver", "Courier"],
      types: ["Collection", "Delivery", "Both"],
      urgencies: ["Urgent", "Medium", "Not Urgent"],
      engineers: [],
      salespersons: [],
      statuses: ["In Queue", "Booked", "In Transit", "Complete", "Delayed"],
      rules: {
        required: (value) => !!value || "Required.",
        workHours: (value) => {
          if (!value) return true;
          const time = value.split(":");
          const hours = parseInt(time[0], 10);
          return (
            (hours >= 9 && hours <= 17) ||
            "Time must be within work hours (09:00 - 17:00)."
          );
        },
      },
      files: [],
      loading: false,
      menu: false,
      timeMenu: false,
      customers: [], // Customers list from Firestore
      suppliers: [], // Suppliers list from Firestore
      loadingLocations: false,
      photoDialog: false,
      confirmDialog: false, // Added confirmation dialog
      snackbar: false, // Added snackbar for success message
    };
  },
  computed: {
    driverNameRules() {
    // Make driver name required only when status is 'Booked' or 'In Transit'
    if (this.delivery.status === "Booked" || this.delivery.status === "In Transit") {
      return [this.rules.required];
    }
    return []; // No validation if status is 'In Queue' or others
  },
    isInTransit() {
    return this.delivery.status === "In Transit";
  },
    isEngineerSelected() {
      return !!this.delivery.engineer; // Returns true if engineer is selected
    },
    isSalespersonSelected() {
      return !!this.delivery.salesperson; // Returns true if salesperson is selected
    },
    formattedDate() {
      // Format the date for display
      return this.delivery.date
        ? new Date(this.delivery.date).toLocaleDateString("en-CA") // Adjust format as needed
        : "";
    },
    reasonRequired() {
      return this.delivery.method === "Courier";
    },
    filteredTypes() {
      return this.delivery.method === "Courier"
        ? ["Collection", "Delivery"]
        : this.types;
    },
    combinedLocations() {
      return [
        ...this.customers.map((customer) => ({
          name: `${customer.companyName} (Customer)`,
          account: customer.customerAccount,
        })),
        ...this.suppliers.map((supplier) => ({
          name: `${supplier.supplierName} (Supplier)`,
          account: supplier.supplierAccount,
        })),
      ];
    },
  },
  async created() {
    await this.fetchUsers();
    await this.fetchDeliveryDetails();
    await this.fetchLocations();
  },
  methods: {
    updateDate(date) {
      // Format the selected date to 'YYYY-MM-DD' and update the delivery date
      this.delivery.date = date
        ? new Date(date).toISOString().substr(0, 10)
        : "";
    },
    async fetchUsers() {
      const usersSnapshot = await getDocs(collection(db, "users"));
      const usersData = usersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      this.engineers = usersData
        .filter((user) => user.role === "Engineer")
        .map((user) => user.fullName);
      this.salespersons = usersData
        .filter((user) => user.role === "Salesperson")
        .map((user) => user.fullName);
    },
    async fetchLocations() {
      this.loadingLocations = true;
      try {
        await Promise.all([this.fetchCustomers(), this.fetchSuppliers()]);
      } finally {
        this.loadingLocations = false;
      }
    },
    async fetchCustomers() {
      try {
        const customersSnapshot = await getDocs(collection(db, "customers"));
        this.customers = customersSnapshot.docs.map((doc) => ({
          companyName: doc.data()["Company Name"] || "",
          customerAccount: doc.data()["Customer Account"] || "",
        }));
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    },
    async fetchSuppliers() {
      try {
        const suppliersSnapshot = await getDocs(collection(db, "suppliers"));
        this.suppliers = suppliersSnapshot.docs.map((doc) => ({
          supplierName: doc.data()["Supplier Name"] || "",
          supplierAccount: doc.data()["Supplier Account"] || "",
        }));
      } catch (error) {
        console.error("Error fetching suppliers:", error);
      }
    },
    async fetchDeliveryDetails() {
      const deliveryId = localStorage.getItem("selectedDelivery"); // Fetch delivery ID from localStorage
      if (deliveryId) {
        try {
          const deliveryDoc = await getDoc(doc(db, "deliveries", deliveryId));
          if (deliveryDoc.exists()) {
            const deliveryData = deliveryDoc.data();

            // Ensure all fields are properly populated
            this.delivery = {
              ...this.delivery, // Spread the existing delivery object to ensure we don't lose any data
              deliveryNumber: deliveryData.deliveryNumber || "",
              method: deliveryData.method || "",
              type: deliveryData.type || "",
              refNumber: deliveryData.refNumber || "",
              invoice: deliveryData.invoice || "",
              poNumber: deliveryData.poNumber || "",
              location: deliveryData.location || "",
              engineer: deliveryData.engineer || "",
              salesperson: deliveryData.salesperson || "",
              reason: deliveryData.reason || "",
              urgency: deliveryData.urgency || "",
              date: deliveryData.date || "", // Handle the date field properly
              time: deliveryData.time || "",
              driverName: deliveryData.driverName || "", // Added driverName field
              status: deliveryData.status || "",
              photos: deliveryData.photos || [],
            };

            // Ensure deliveryItems is properly set as an array
            if (
              deliveryData.deliveryItems &&
              Array.isArray(deliveryData.deliveryItems)
            ) {
              this.deliveryItems = deliveryData.deliveryItems;
            } else {
              this.deliveryItems = [];
            }
          } else {
            console.error("No such document!");
          }
        } catch (error) {
          console.error("Error fetching delivery details: ", error);
        }
      } else {
        console.error("No delivery ID found in localStorage");
      }
    },
    handleMethodChange() {
      if (this.delivery.method === "Courier") {
        this.delivery.type = ""; // Clear the type when method changes to Courier
      }
    },
    addMoreDeliveryItems() {
      this.deliveryItems.push({
        qty: "",
        code: "",
        description: "",
        refnum: "",
      });
    },
    removeDeliveryItem(index) {
      this.deliveryItems.splice(index, 1);
    },
    allowedDates(val) {
      const today = new Date();
      const futureDate = new Date();
      futureDate.setDate(today.getDate() + 2);
      return val <= futureDate.toISOString().substr(0, 10);
    },
    async uploadFiles() {
      const storage = getStorage(firebaseApp);
      const fileUrls = await Promise.all(
        this.files.map(async (file) => {
          const storageRef = ref(storage, `deliveries/${file.name}`);
          await uploadBytes(storageRef, file);
          return await getDownloadURL(storageRef);
        })
      );
      return fileUrls;
    },
    confirmSave() {
      this.confirmDialog = true; // Show the confirmation dialog
    },
    async submit() {
      const deliveryId = localStorage.getItem("selectedDelivery");
      if (deliveryId) {
        this.loading = true;
        const deliveryRef = doc(db, "deliveries", deliveryId);
        const fileUrls = await this.uploadFiles();
        if (fileUrls.length > 0) {
          this.delivery.photos = fileUrls;
        }
        try {
          await updateDoc(deliveryRef, {
            ...this.delivery,
            deliveryItems: this.deliveryItems, // Include delivery items in the update
          });
          console.log("Delivery details updated successfully");
          this.confirmDialog = false;
          this.snackbar = true; // Show success message
        } catch (error) {
          console.error("Error updating delivery details: ", error);
        } finally {
          this.loading = false;
        }
      } else {
        console.error("No delivery ID found in local storage");
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap");

body,
div,
h2,
v-card,
v-text-field,
v-textarea,
v-select,
v-btn {
  font-family: "Montserrat", sans-serif;
}

.job-title {
  color: red;
  text-align: center;
  font-weight: bold;
  margin-bottom: 20px;
}

.save-button {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  margin-top: 20px;
  background-color: red;
  color: white;
  border-radius: 8px;
}

.back-button {
  color: white;
  background-color: red;
  border-radius: 50%;
  transition: transform 0.3s ease-in-out;
}

.back-button:hover {
  transform: scale(1.1);
}

.back-button .v-icon {
  color: white;
}
</style>
